import { useState } from "react";
import logoMark from "../assets/logo-mark.png";
import LegalModal from "./LegalModal";

export default function Footer() {
  const [legalOpen, setLegalOpen] = useState(false);

  return (
    <footer className="border-t border-ink/[0.06] bg-paper">
      <div className="mx-auto max-w-content px-5 py-12 sm:px-8">
        <div className="flex flex-col gap-10 sm:flex-row sm:items-start sm:justify-between">
          <div className="max-w-xs">
            <a href="#top" className="flex items-center gap-2.5">
              <img
                src={logoMark}
                alt="Hygio"
                className="h-8 w-8 rounded-[8px]"
              />
              <span className="text-base font-semibold tracking-tight text-ink">
                Hygio
              </span>
            </a>
            <p className="mt-3 text-sm leading-relaxed text-ink-soft">
              L'application tout-en-un des commerces alimentaires
              indépendants : équipe, planning, conformité et pilotage réunis
              dans un seul outil.
            </p>
          </div>

          <div className="grid grid-cols-2 gap-8 sm:flex sm:gap-16">
            <div>
              <h4 className="text-sm font-semibold text-ink">Le site</h4>
              <ul className="mt-3 space-y-2.5">
                <li>
                  <a
                    href="#fonctionnalites"
                    className="text-sm text-ink-soft hover:text-ink"
                  >
                    Fonctionnalités
                  </a>
                </li>
                <li>
                  <a
                    href="#pourquoi-hygio"
                    className="text-sm text-ink-soft hover:text-ink"
                  >
                    Pourquoi Hygio
                  </a>
                </li>
                <li>
                  <a
                    href="#contact"
                    className="text-sm text-ink-soft hover:text-ink"
                  >
                    Demander une démo
                  </a>
                </li>
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-ink">Contact</h4>
              <ul className="mt-3 space-y-2.5">
                <li>
                  <a
                    href="mailto:contact@hygio.fr"
                    className="text-sm text-ink-soft hover:text-ink"
                  >
                    contact@hygio.fr
                  </a>
                </li>
                <li>
                  <button
                    type="button"
                    onClick={() => setLegalOpen(true)}
                    className="text-sm text-ink-soft hover:text-ink"
                  >
                    Mentions légales
                  </button>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div className="mt-10 flex flex-col-reverse items-start gap-4 border-t border-ink/[0.06] pt-6 sm:flex-row sm:items-center sm:justify-between">
          <p className="text-xs text-ink-soft">
            © {new Date().getFullYear()} Hygio. Tous droits réservés.
          </p>
          <button
            type="button"
            onClick={() => setLegalOpen(true)}
            className="text-xs text-ink-soft underline decoration-ink-soft/30 underline-offset-2 hover:text-ink"
          >
            Mentions légales & RGPD
          </button>
        </div>
      </div>

      <LegalModal open={legalOpen} onClose={() => setLegalOpen(false)} />
    </footer>
  );
}
